export { buildCitationsArray } from './utils/build-citation-array'
export { cleanPatentNumber } from './utils/clean-document-number'
export { clearIDB, createDexiePersister } from './utils/create-dexie-persister'
export { createQueryString } from './utils/create-query-string'
export { dateToString } from './utils/date-to-string'
export { deduplicateDescriptionArray } from './utils/deduplicate-description-array'
export {
  processDocumentNumbersCsv,
  validateDocumentNumbers,
} from './utils/document-number-validation'
export type {
  DocumentNumberValidationResult,
  ValidateDocumentNumbersOptions,
} from './utils/document-number-validation'
export * from './utils/field-errors/form-error'
export * from './utils/field-errors/from-api'
export * from './utils/field-errors/from-zod'
export { getApplicationNumberFromReference } from './utils/format-application-number'
export { getFamilyTree } from './utils/get-family-tree'
export type {
  ProcessedFamilyNode,
  ProcessedFamilyTree,
} from './utils/get-family-tree'
export { getFigures } from './utils/get-figures'
export { event, pageview } from './utils/gtag'
export { convertHexColorToRgbWithOpacity } from './utils/highlights/convert-hex-color-to-rgb-with-opacity'
export { countHighlights } from './utils/highlights/count-highlights'
export {
  createHighlightKeywordsConfig,
  highlightKeywords,
} from './utils/highlights/highlight-keywords'
export type { HighlightConfig } from './utils/highlights/highlight-keywords'
export type {
  ColoredHighlight,
  ColoredHighlightCount,
} from './utils/highlights/types'
export * from './utils/is-error-key'
export { isInJurisdiction } from './utils/is-in-jurisdiction'
export { logError } from './utils/log-error'
export { openInNewTab } from './utils/open-in-new-tab'
export * from './utils/partner-search'
export { readStream } from './utils/read-stream'
export {
  isRedirectError,
  RedirectError,
  throwRedirect,
} from './utils/redirect-error'
export { removeProcedureNameErrorPrefix } from './utils/remove-procedure-name-error-prefix'
export { stripHTML } from './utils/strip-html'
export { Time } from './utils/time'
export { trimMarkdownBlock } from './utils/trim-markdown-block'
export { validatePatentFormat } from './utils/validate-patent-format'
export { wrapWithNonNullFallback } from './utils/wrap-with-non-null-fallback'
export { addPatentLinksToMarkdown } from './utils/add-patent-links-to-markdown'
export { shouldDescriptionHaveParagraphNumbers } from './utils/should-description-have-paragraph-numbers'
export { catchWithSentryCapture } from './utils/catch-with-sentry-capture'
export { processDescriptionParagraphs } from './utils/process-description-paragraphs'
